var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"}},[_c('div',[_c('vue-editor',{ref:"qeditor",staticClass:"text-editor",style:({ height: _vm.height }),model:{value:(_vm.valueData),callback:function ($$v) {_vm.valueData=$$v},expression:"valueData"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }